import Head from "next/head";
import React from "react";
import withHeader from "hocs/withHeader";
import withFooter from "hocs/withFooter";
import Pricing from "containers/Pricing/Pricing";
import { ProductProvider } from "@context";

const PricingPage = () => {
	return (
		<>
			<Head>
				<title> Vinglet - Pricing </title>
			</Head>
			<ProductProvider>
				<Pricing />
			</ProductProvider>
		</>
	);
};

export default withHeader(withFooter(PricingPage));
